/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
/* eslint-disable-next-line react/jsx-boolean-value */
import React, { useEffect, useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Nav,
  Row,
  Col,
  Navbar,
  Button,
  Dropdown,
  Card,
} from "react-bootstrap";
import ImageElement from "components/UiElement/ImageElement";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/autoplay";
import {
  Thumbs,
  // Navigation,
  FreeMode,
  Pagination,
  Autoplay,
} from "swiper/modules";
import {
  AntTextArea,
  CommonButton,
  RippleEffect,
  Upload,
  Checkbox,
} from "components";
import config from "config";
import routesMap from "routeControl/userRouteMap";
import Input from "components/Antd/Input/index.ant";
import ModalComponent from "components/UiElement/Modal/Index";
import { Select } from "antd";
import { getSessionStorage, setSessionStorage } from "utils";

/* eslint-disable */
function Theme04() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isActiveMap, setIsActiveMap] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const oneSubscriptionData = getSessionStorage("oneSubscriptionData");

  const navigate = useNavigate();
  const path = {
    1: `${routesMap?.LAYOUTFOUR?.path}/${1}`,
    4: `${routesMap?.LAYOUTFOUR?.path}/${4}`,
    3: routesMap?.LAYOUTTHREE?.path,
  };

  const Navigation = () => {
    console.log("oneSubscriptionData", oneSubscriptionData);
    if (oneSubscriptionData && oneSubscriptionData?.memorialId === null) {
      navigate(path?.[oneSubscriptionData?.subscription?.layout]);
      setSessionStorage("oneSubscriptionData", oneSubscriptionData);
    } else {
      navigate(routesMap?.CHOOSE_PLAN?.path);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsActiveMap(false);
    };
    handleResize();
    // Add event listener for window resize
    window.addEventListener("resize", handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  const toggleClassMap = () => {
    if (windowWidth <= 991) {
      setIsActiveMap(!isActiveMap);
    }
  };
  const handleCloseMap = () => {
    setIsActiveMap(false);
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  //  header click section redirect function
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    let navbarMenu = document.querySelector(".theme04Header").clientHeight;
    setOffset(navbarMenu);
  });
  // share modal
  const [shareModal, setShareModal] = useState(false);
  const handleCloseModal = () => {
    setShareModal(false);
  };
  // comment Modal
  const [commentModal, setCommentModal] = useState(false);
  const handleCloseModalComment = () => {
    setCommentModal(false);
  };

  /* report modal */
  const [showReportModal, setReportModal] = useState(false);
  const handleCloseModalReport = () => {
    setReportModal(false);
  };
  /* image modal memory */
  const [showModalImageMemory, setModalImageMemory] = useState(false);
  const handleCloseModalImageMemory = () => {
    setModalImageMemory(false);
  };
  /* image modal */
  const [showModalImage, setModalImage] = useState(false);
  const handleCloseModalImage = () => {
    setModalImage(false);
  };
  /* memeories video modal */
  const [showVideoModal, setVideoModal] = useState(false);
  const handleCloseModalVideo = () => {
    setVideoModal(false);
  };
  /* memeories full video modal */
  const [showVideoFullModal, setVideoFullModal] = useState(false);
  const handleCloseModalVideoFull = () => {
    setVideoFullModal(false);
    setVideoModal(true);
  };
  const handleVideoFullShow = () => {
    setVideoFullModal(true);
    setVideoModal(false);
  };
  /* memeories full image modal */
  const [showImageFullModal, setImageFullModal] = useState(false);
  const handleCloseModalImageFull = () => {
    setImageFullModal(false);
    setVideoModal(true);
  };
  const handleImageFullShow = () => {
    setImageFullModal(true);
    setVideoModal(false);
  };
  /* memeories audio modal */
  const [showAudioModal, setAudioModal] = useState(false);
  const handleCloseModalAudio = () => {
    setAudioModal(false);
  };

  /* memeories pdf modal */
  const [showPdfModal, setPdfModal] = useState(false);
  const handleCloseModalPdf = () => {
    setPdfModal(false);
  };
  const nodeBinding = {
    userImage: "img",
    userName: "name",
    userRelation: "relation",
    userBirth: "born",
  };
  const videoMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-01.webp",
      alt: "",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
    {
      id: 2,
      name: "Love & Relationships",
      duration: "08:45",
      thumbnail: "modal-video-02.webp",
      imageShow: true,
      videoDuration: false,
      videoIcon: false,
      imageIcon: true,
    },
    {
      id: 3,
      name: "Adventures in Youth",
      duration: "08:45",
      thumbnail: "modal-video-03.webp",
      imageShow: true,
      videoDuration: false,
      videoIcon: false,
      imageIcon: true,
    },
    {
      id: 4,
      name: "Innocence Unveiled",
      duration: "08:45",
      thumbnail: "modal-video-04.webp",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
    {
      id: 5,
      name: "Teenage Dreams",
      duration: "08:45",
      thumbnail: "modal-video-05.webp",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
    {
      id: 6,
      name: "Friendship Chronicles",
      duration: "08:45",
      thumbnail: "modal-video-06.webp",
      imageShow: false,
      videoDuration: true,
      videoIcon: true,
      imageIcon: false,
    },
  ];
  const audioMemories = [
    {
      id: 1,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 2,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 3,
      name: "Innocence Unveiled",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 4,
      name: "Adventures in Youth",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 5,
      name: "Friendship Chronicles",
      audioUrl: "",
      duration: "09:45",
    },
    {
      id: 6,
      name: "Journey of Love",
      audioUrl: "",
      duration: "09:45",
    },
  ];
  /* PDF Modal Select */
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [individualCheckboxes, setIndividualCheckboxes] = useState(
    Array(6).fill(false)
  );
  /* Map modal */
  const [showModalMap, setShowModalMap] = useState(false);
  const handleCloseModalMap = () => {
    setShowModalMap(false);
  };
  const handleCheckboxChange = (index) => {
    const updatedCheckboxes = [...individualCheckboxes];
    updatedCheckboxes[index] = !updatedCheckboxes[index];
    setIndividualCheckboxes(updatedCheckboxes);
    const allChecked = updatedCheckboxes.every((checkbox) => checkbox);
    setSelectAllChecked(allChecked);
  };
  const handleSelectAll = () => {
    const allChecked = !selectAllChecked;
    setSelectAllChecked(allChecked);
    setIndividualCheckboxes(Array(6).fill(allChecked));
  };
  /* audio Modal Select */
  const [selectAllCheckedAudio, setSelectAllCheckedAudio] = useState(false);
  const [individualCheckboxesAudio, setIndividualCheckboxesAudio] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeAudio = (index) => {
    const updatedCheckboxesAudio = [...individualCheckboxesAudio];
    updatedCheckboxesAudio[index] = !updatedCheckboxesAudio[index];
    setIndividualCheckboxesAudio(updatedCheckboxesAudio);
    const allCheckedAudio = updatedCheckboxesAudio.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedAudio(allCheckedAudio);
  };
  const handleSelectAllAudio = () => {
    const allCheckedAudio = !selectAllCheckedAudio;
    setSelectAllCheckedAudio(allCheckedAudio);
    setIndividualCheckboxesAudio(Array(6).fill(allCheckedAudio));
  };
  /* video Modal Select */
  const [selectAllCheckedVideo, setSelectAllCheckedVideo] = useState(false);
  const [individualCheckboxesVideo, setIndividualCheckboxesVideo] = useState(
    Array(6).fill(false)
  );
  const handleCheckboxChangeVideo = (index) => {
    const updatedCheckboxesVideo = [...individualCheckboxesVideo];
    updatedCheckboxesVideo[index] = !updatedCheckboxesVideo[index];
    setIndividualCheckboxesVideo(updatedCheckboxesVideo);
    const allCheckedVideo = updatedCheckboxesVideo.every(
      (checkbox) => checkbox
    );
    setSelectAllCheckedVideo(allCheckedVideo);
  };
  const handleSelectAllVideo = () => {
    const allCheckedVideo = !selectAllCheckedVideo;
    setSelectAllCheckedVideo(allCheckedVideo);
    setIndividualCheckboxesVideo(Array(6).fill(allCheckedVideo));
  };

  //  ********************* Family tree functions *************************
  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      setIsFullscreen(false);
    } else {
      document.querySelector(".familyTreeContainer").requestFullscreen();
      setIsFullscreen(true);
      fitToScreen();
    }
  };

  let tree = document.querySelector(".parent");
  let eleWidth = document.querySelector(".tree");
  let screenWidthOut = eleWidth?.offsetWidth;
  let treeWidthOut = tree?.offsetWidth;
  let screenHeight = screen.height;
  let initialDistance,
    initialZoomValue = 1,
    currentZoomValue = 1;
  let startX, startY, startLeft, startTop;
  let lastTapTime = 0,
    tapTimer,
    doubleTapCount = 0;
  let isDragging = false;

  function fitToScreen() {
    let screenWidth = eleWidth?.offsetWidth;
    let treeWidth = tree?.offsetWidth;
    if (treeWidth > screenWidth) {
      let scale = screenWidth / treeWidth;
      if (tree) {
        tree.style.transform = `scale(${scale})`;
        currentZoomValue = scale;
      }
      let trAddHeight = tree?.getBoundingClientRect().height;
      eleWidth.style.height = `${trAddHeight}px`;
      tree.style.top = "auto";
      tree.style.left = "auto";
    } else {
      if (tree) {
        tree.style.transform = "scale(1)";
        tree.style.top = "auto";
        tree.style.left = "auto";
      }
    }
    doubleTapCount = 0;
  }
  window.mobileAndTabletCheck = function () {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };
  function mobileCheck() {
    if (mobileAndTabletCheck() && screenHeight == screen.height) {
      return false;
    } else {
      screenHeight = screen.height;
    }
    fitToScreen();
  }
  window.addEventListener("resize", mobileCheck);
  useEffect(() => {
    fitToScreen();
  }, [tree]);
  function calculateDistance(touches) {
    let dx = touches[0].clientX - touches[1].clientX;
    let dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  function handlePinch(event) {
    let currentDistance = calculateDistance(event.touches);
    let delta = currentDistance - initialDistance;
    let zoomFactor = delta * 0.01;
    currentZoomValue = initialZoomValue + zoomFactor;
    if (currentZoomValue < 0.16) {
      currentZoomValue = 0.16;
    }
    if (currentZoomValue > 2) {
      currentZoomValue = 2;
    }
    tree.style.transform = "scale(" + currentZoomValue + ")";
  }
  function zoomIn() {
    if (currentZoomValue < 2) {
      currentZoomValue += 0.1;
      tree.style.transform = `scale(${currentZoomValue})`;
    }
  }
  function zoomOut() {
    if (currentZoomValue > 0.16) {
      currentZoomValue -= 0.1;
      tree.style.transform = `scale(${currentZoomValue})`;
    }
  }
  tree?.addEventListener("wheel", function (event) {
    event.preventDefault();
    if (event.deltaY < 0) {
      zoomIn();
    } else {
      zoomOut();
    }
  });
  function handleDoubleTap(event) {
    let currentTime = new Date().getTime();
    let tapTimeDifference = currentTime - lastTapTime;
    clearTimeout(tapTimer);
    if (tapTimeDifference < 300 && tapTimeDifference > 0) {
      if (currentZoomValue < 2) {
        if (doubleTapCount % 2 === 0) {
          tree.style.transform = "scale(" + (currentZoomValue + 0.5) + ")";
        } else {
          fitToScreen();
          doubleTapCount++;
        }
        doubleTapCount++;
      } else {
        fitToScreen();
      }
    } else {
      tapTimer = setTimeout(function () {
        clearTimeout(tapTimer);
      }, 300);
    }
    lastTapTime = currentTime;
  }
  tree?.addEventListener("touchstart", function (event) {
    if (event.touches.length === 1) {
      isDragging = true;
      let touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startLeft = parseInt(tree?.style.left) || 0;
      startTop = parseInt(tree?.style.top) || 0;
      tree.classList.add("noselect");
      tree.style.cursor = "grabbing";
    }
    if (event.touches.length === 2) {
      initialDistance = calculateDistance(event.touches);
      initialZoomValue = currentZoomValue;
    }
  });
  tree?.addEventListener("touchmove", function (event) {
    if (isDragging && event.touches.length === 1) {
      let touch = event.touches[0];
      let offsetX = touch.clientX - startX;
      let offsetY = touch.clientY - startY;
      if (tree) {
        tree.style.left = startLeft + offsetX + "px";
        tree.style.top = startTop + offsetY + "px";
      }
      event.preventDefault();
    }
    if (event.touches.length === 2) {
      handlePinch(event);
      event.preventDefault();
    }
  });
  tree?.addEventListener("touchend", function (event) {
    if (event.touches.length === 0) {
      handleDoubleTap(event);
    }
    if (event.touches.length < 2) {
      initialZoomValue = currentZoomValue;
    }
  });
  tree?.addEventListener("touchend", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });

  tree?.addEventListener("mousedown", function (event) {
    isDragging = true;
    startX = event.clientX;
    startY = event.clientY;
    startLeft = parseInt(tree?.style.left) || 0;
    startTop = parseInt(tree?.style.top) || 0;
    tree.classList.add("noselect");
    tree.style.cursor = "grabbing";
  });
  tree?.addEventListener("mouseup", function () {
    isDragging = false;
    if (tree) {
      tree.classList.remove("noselect");
      tree.style.cursor = "grab";
    }
  });
  tree?.addEventListener("mousemove", function (event) {
    if (isDragging) {
      let offsetX = event.clientX - startX;
      let offsetY = event.clientY - startY;
      if (tree) {
        tree.style.left = startLeft + offsetX + "px";
        tree.style.top = startTop + offsetY + "px";
      }
    }
  });

  return (
    <>
      {/* Header 4 Start */}
      <header className={`theme04Header ${isScrolled ? "scrolled" : ""}`}>
        <Navbar expand="lg" className="p-0">
          <Container>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <Navbar.Brand
                  href="#"
                  className={`p-0 me-0 ${isScrolled ? "d-none" : "d-block"}`}
                >
                  <Link to={routesMap.USERDASHBOARD.path}>
                    <ImageElement source="white-logo.svg" className="img-fluid" alt="logo" />
                  </Link>
                </Navbar.Brand>
                <Navbar.Brand
                  href="#"
                  className={`p-0 me-0 ${isScrolled ? "d-block" : "d-none"}`}
                >
                  <Link to={routesMap.USERDASHBOARD.path}>
                    <ImageElement source="logo.svg" alt="logo" />
                  </Link>
                </Navbar.Brand>
              </div>
              <div className="d-flex align-items-center">
                <Navbar.Toggle aria-controls="navbarScroll" className="order-3">
                  <em className="icon-menu" />
                </Navbar.Toggle>
                {/* <div> */}
                <Navbar.Collapse id="navbarScroll">
                  <Nav className="ms-auto my-lg-0" navbarScroll>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="about"
                      spy
                      smooth
                      offset={-offset}
                      duration={500}
                    >
                      About
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="gallery"
                      spy
                      smooth
                      offset={-offset}
                      duration={500}
                    >
                      Gallery
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="timeline"
                      spy
                      smooth
                      offset={-offset}
                      duration={500}
                    >
                      Timeline
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="story"
                      spy
                      smooth
                      offset={-offset}
                      duration={500}
                    >
                      Story
                    </ScrollLink>
                    <ScrollLink
                      activeClass="active"
                      className="nav-link"
                      to="familytree"
                      spy
                      smooth
                      offset={-offset}
                      duration={500}
                    >
                      Family tree
                    </ScrollLink>
                  </Nav>
                </Navbar.Collapse>

                {/* Button for see other's biography */}
                {/* <RippleEffect extraClassName="justify-content-end me-md-3 me-2">
                  <CommonButton variant="white" size="sm" className="rounded">
                    <em className="icon-saved me-sm-2 text-dark" />
                    <span className="d-none d-sm-block text-dark">Save</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect extraClassName="justify-content-end ms-xxl-1 ms-0">
                  <CommonButton variant="danger" size="sm" className="rounded">
                    <em className="icon-share me-sm-2" />
                    <span
                      className="d-none d-sm-block"
                      onClick={() => setShareModal(true)}
                    >
                      Share
                    </span>
                  </CommonButton>
                </RippleEffect> */}

                {/* Button for theme published */}
                {/* <Dropdown className="d-flex justify-content-center align-items-center actionDropdown btnCenter me-md-3 me-2">
                      <Dropdown.Toggle variant="white"  size="sm" className="rounded">
                            <span className="text-dark">Action</span>
                            <em className="icon-arrow-down ms-sm-2 d-none d-sm-block text-dark" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="border-0 p-0 rounded">
                        <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                        <em className="icon-edit me-2" /> Edit
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                        <em className="icon-saved me-2" /> Save
                        </Dropdown.Item>
                      </Dropdown.Menu>
                  </Dropdown>
                  <RippleEffect extraClassName="justify-content-end ms-xxl-1 ms-0">
                  <CommonButton variant="danger" size="sm" className="rounded">
                    <em className="icon-share me-sm-2" />
                    <span
                      className="d-none d-sm-block"
                      onClick={() => setShareModal(true)}
                    >
                      Share
                    </span>
                  </CommonButton>
                </RippleEffect> */}

                {/* Button for theme published */}
                <Dropdown className="d-flex justify-content-center align-items-center actionDropdown btnCenter me-md-3 me-2">
                  <Dropdown.Toggle
                    variant="white"
                    size="sm"
                    className="rounded"
                  >
                    <span className="d-none d-sm-block">Action</span>
                    <em className="icon-dots ms-sm-2 d-block d-sm-none" />
                    <em className="icon-arrow-down ms-sm-2 d-none d-sm-block text-dark" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="border-0 p-0 rounded">
                    <Dropdown.Item
                      href="#/action-1"
                      className="d-flex align-items-center"
                    >
                      <em className="icon-edit me-2" /> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#/action-1"
                      className="d-flex align-items-center"
                    >
                      <em className="icon-close me-2" /> Close
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <RippleEffect extraClassName="justify-content-end me-md-3 me-2">
                  <CommonButton variant="danger" size="sm" className="rounded w-auto">
                    <span>Publish</span>
                  </CommonButton>
                </RippleEffect>
                <RippleEffect extraClassName="justify-content-end">
                  <CommonButton
                    onClick={(e) => {
                      e.preventDefault();
                      Navigation();
                    }}
                    variant="outline-white" size="sm" className="rounded"
                  >
                    <em className="icon-arrow-prev me-sm-2" />
                    <span className="d-none d-sm-block">Back</span>
                  </CommonButton>
                </RippleEffect>
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
      {/* Header End */}
      <main className="theme04Page">
        <section className="">
          {/* Banner Start */}
          <div
            className="banner position-relative overflow-hidden"
            style={{
              backgroundImage: `url(${config.BASENAME}/assets/images/frontend/theme04/theme04-banner.webp)`,
              backgroundSize: "cover",
            }}
          >
            <div className="d-flex align-items-center banner_cnt">
              <Container>
                <div className="banner_cnt_card">
                  <h1>Tommy M. Lawrence</h1>
                  <div className="txt">May 21, 1948 - Dec 15, 2005</div>
                  <span className="d-flex align-items-center txt">
                    <em className="icon-location" />
                    Los Angeles, US
                  </span>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled.
                  </p>
                  <div className="d-flex align-items-center justify-content-between">
                    {/* Social Icons */}
                    <ul className="list-inline mb-0 banner_cnt_social">
                      <li className="list-inline-item">
                        <Link
                          to="#"
                          className="d-flex align-items-center justify-content-center"
                          aria-label="instagram"
                        >
                          <em className="icon-instagram" />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="#"
                          className="d-flex align-items-center justify-content-center"
                          aria-label="twitter"
                        >
                          <em className="icon-twitter" />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="#"
                          className="d-flex align-items-center justify-content-center"
                          aria-label="facebook"
                        >
                          <em className="icon-facebook" />
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to="#"
                          aria-label="report"
                          className="d-flex align-items-center justify-content-center"
                          onClick={() => setReportModal(true)}
                        >
                          <em className="icon-report" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Container>
            </div>
          </div>
          {/* Banner End */}
        </section>
        <section id="about">
          <div className="bannerInfo">
            <div className="">
              <ul className="list-unstyled d-flex align-items-strecth mb-0">
                <li className="text-center">
                  <h3>Born</h3>
                  <p className="mb-0">September 21, 1985 (age 38 years)</p>
                </li>
                <li className="text-center">
                  <h3>Birth Place</h3>
                  <p className="mb-0">Los Angeles, United States</p>
                </li>
                <li className="text-center">
                  <h3>Spouse</h3>
                  <p className="mb-0">
                    Terry A. Perkins <br className="d-xxl-block d-none" /> (m.
                    2014)
                  </p>
                </li>
                <li className="text-center">
                  <h3>Parents</h3>
                  <p className="mb-0">
                    Robert C.McCormick, Kasandra J. McCormick
                  </p>
                </li>
                <li className="text-center">
                  <h3>Children</h3>
                  <p className="mb-0">
                    Kevin J. Perkins,
                    <br className="d-xxl-block d-none" /> Andrew J. Perkins{" "}
                  </p>
                </li>
                <li className="text-center">
                  <h3>Siblings</h3>
                  <p className="mb-0">Mallory A. McCormick</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="biographySec py-80">
          <Container>
            <Row>
              <Col md={4} sm={12}>
                <div className="commonHead mb-0">
                  <span className="commonHead_sub">Biography</span>
                  <h2 className="commonHead_title mb-0">
                    Echoes of a <br className="d-xxl-block d-none" /> Lifetime,
                    the <br className="d-xxl-block d-none" /> Unseen
                  </h2>
                </div>
              </Col>
              <Col md={8} sm={12}>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting,
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting,
                </p>
              </Col>
            </Row>
          </Container>
          <div className="downloadSec">
            <Container>
              <div className="downloadSec_inner rounded-0">
                <Row className="justify-content-md-between">
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme04">
                      <div
                        className="storyCard_img position-relative storyCard_img-audio cursor-pointer"
                        onClick={() => setAudioModal(true)}
                      >
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-mic" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">Audio</h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme04">
                      <div
                        className="storyCard_img position-relative videoImg storyCard_img-image cursor-pointer"
                        onClick={() => setVideoModal(true)}
                      >
                        <div className="image">
                          <ImageElement
                            className="img-fluid w-100 h-100 object-fit-cover"
                            source="downloadable-img .webp"
                          />
                        </div>
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-img-video" />
                        </div>
                        {/* <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center" onClick={() => setVideoModal(true)}>
                          <em className="icon-video" />
                          </div> */}
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">
                        Image & Video
                      </h2>
                    </div>
                  </Col>
                  <Col xxl={2} md={3} sm={4} xs={6}>
                    <div className="storyCard storyCard-theme04">
                      <div
                        className="storyCard_img position-relative storyCard_img-pdf cursor-pointer"
                        onClick={() => setPdfModal(true)}
                      >
                        <div className="storyCard_btn position-absolute d-flex justify-content-center align-items-center">
                          <em className="icon-pdf" />
                        </div>
                      </div>
                      <h2 className="storyCard_txt text-center mb-0">PDF</h2>
                    </div>
                  </Col>
                  <Col xxl={4} md={3} sm={6} xs={6}>
                    <div className="d-flex h-100 flex-column justify-content-center storyCnt">
                      <h2>Downloadable Memories</h2>
                      <p className="mb-1 ps-0">
                        Sharing a life legacy for generations to come.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </section>
        <section className={`landmarkSec ${isActiveMap ? "active" : ""}`}>
          <div className="landmarkSec_heading py-80 pb-0">
            <Container>
              <div className="commonHead mb-0">
                <Row className="align-items-end justify-content-between">
                  <Col sm={12} className="mb-sm-0 mb-3 text-center">
                    <div className="commonHead_sub">
                      Click an image to view a timeless memory
                    </div>
                    <h2 className="commonHead_title mb-0">
                      Timeless Memories and Significant Places
                    </h2>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
          <div
            className="mapSection position-relative"
            onClick={toggleClassMap}
          >
            <div className="mapSection_map">
              <div className="mapOverlay" />
              <ImageElement
                source="theme04/map.webp"
                className="img-fluid w-100 h-100 object-fit-cover"
                alt="map"
              />
            </div>
            <div className="mapSection_card">
              <Card className="position-relative">
                <Link className="closeBtn" onClick={handleCloseMap}>
                  <em className="icon-close" />
                </Link>
                <Card.Header className="bg-white">
                  <div className="profileImg d-flex align-items-center">
                    <ImageElement
                      className="img-fluid w-100 h-100 object-fit-cover cursor-pointer"
                      source="theme03/theme03-map-detail.webp"
                      onClick={() => setShowModalMap(true)}
                    />
                  </div>
                </Card.Header>
                <Card.Body className="bg-white">
                  <span className="d-block date">20 Feb 2023</span>
                  <h3>Friendship Saga, Journeying Through Bonds</h3>
                  <span className="location">
                    <em className="icon-location me-1" />
                    San Francisco, CL
                  </span>
                  <div className="content">
                    {/* <p>
                      <span>Delving into the intricate tapestry of genuine friendship,
                      we unravel a narrative woven with laughter, unwavering
                      loyalty.</span>
                    </p> */}
                    <p>
                      <span>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled .
                      </span>
                      <Link href="#">Read More</Link>
                    </p>
                  </div>
                </Card.Body>
                <Card.Footer className="bg-white d-flex justify-content-between align-items-end count">
                  <div className="me-1 count_txt">
                    <span>1 </span>/ 12
                  </div>
                  <div className="flex-shrink-0">
                    <RippleEffect>
                      <Button
                        type="button"
                        className="btn btn-light count_btn me-2 me-lg-3"
                      >
                        <em className="icon-arrow-right count_btn_arrowLeft" />
                      </Button>
                    </RippleEffect>
                    <RippleEffect>
                      <Button
                        type="button"
                        className="btn btn-danger count_btn"
                      >
                        <em className="icon-arrow-right" />
                      </Button>
                    </RippleEffect>
                  </div>
                </Card.Footer>
              </Card>
            </div>
          </div>
        </section>
        {/* captured moments section  */}
        <section className="capturedSec py-80" id="gallery">
          <Container>
            <div className="commonHead text-center">
              <div className="commonHead_sub">
                Photographs- Videos- Other Media
              </div>
              <h2 className="commonHead_title mb-0">Captured Memories</h2>
            </div>

            <Row className="g-3">
              <Col lg={4} sm={6}>
                <div
                  className="capturedSec_card"
                  onClick={() => setModalImageMemory(true)}
                >
                  <ImageElement
                    source="theme04/navigating.webp"
                    className="img-fluid"
                    alt="navigating"
                  />
                  <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
                    <h3>
                      Navigating the
                      <br /> Campus of Life
                    </h3>
                    <em className="icon-album" />
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div
                  className="capturedSec_card"
                  onClick={() => setModalImageMemory(true)}
                >
                  <ImageElement
                    source="theme04/graduation.webp"
                    className="img-fluid"
                    alt="graduation"
                  />
                  <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
                    <h3>
                      From Crayons to
                      <br /> Graduation
                    </h3>
                    <em className="icon-album" />
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div
                  className="capturedSec_card"
                  onClick={() => setModalImageMemory(true)}
                >
                  <ImageElement
                    source="theme04/lifetime-frames.webp"
                    className="img-fluid"
                    alt="lifetime-frames"
                  />
                  <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
                    <h3>
                      A Lifetime in
                      <br /> Frames
                    </h3>
                    <em className="icon-album" />
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div
                  className="capturedSec_card"
                  onClick={() => setModalImageMemory(true)}
                >
                  <ImageElement
                    source="theme04/early-years.webp"
                    className="img-fluid"
                    alt="early-years"
                  />
                  <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
                    <h3>
                      The Early
                      <br /> Years
                    </h3>
                    <em className="icon-album" />
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div
                  className="capturedSec_card"
                  onClick={() => setModalImageMemory(true)}
                >
                  <ImageElement
                    source="theme04/family-bonds.webp"
                    className="img-fluid"
                    alt="family-bonds"
                  />
                  <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
                    <h3>
                      Family <br />
                      Bonds
                    </h3>
                    <em className="icon-album" />
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div
                  className="capturedSec_card"
                  onClick={() => setModalImageMemory(true)}
                >
                  <ImageElement
                    source="theme04/matrimonial-journey.webp"
                    className="img-fluid"
                    alt="matrimonial-journey"
                  />
                  <div className="capturedSec_card_cnt d-flex align-items-center justify-content-between w-100">
                    <h3>
                      Our Matrimonial <br />
                      Journey{" "}
                    </h3>
                    <em className="icon-album" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* The Evolution of a Story */}
        <section className="evolutionSec bg-light-yellow py-80" id="timeline">
          <Container>
            <div className="commonHead text-center">
              <div className="commonHead_sub">Chronicles of a Life</div>
              <h2 className="commonHead_title mb-0">
                A Timeline of Meaningful Memories
              </h2>
            </div>

            <div className="position-relative">
              {/* thumbnail  */}
              <Swiper
                onSwiper={setThumbsSwiper}
                loop={false}
                spaceBetween={0}
                slidesPerView={3}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="evolutionSec_thumb mb-xl-5 mb-3"
                breakpoints={{
                  375: { slidesPerView: 4 },
                  480: { slidesPerView: 5 },
                  640: { slidesPerView: 6 },
                  768: { slidesPerView: 8 },
                  1200: { slidesPerView: 9 },
                }}
              >
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>20 Mar 1990</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>01 Oct 1995</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>14 Dec 2001</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>23 Feb 2002</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>10 Sep 2005</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>13 Nov 2010</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>23 Dec 2015</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>18 Feb 2018</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>30 Jan 2019</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>13 Feb 2020</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="evolutionSec_thumbnail">
                    <p>20 Mar 2021</p>
                  </div>
                </SwiperSlide>
              </Swiper>
              {/* main Slider  */}
              <Swiper
                loop={false}
                spaceBetween={10}
                navigation={true}
                thumbs={{
                  swiper:
                    thumbsSwiper && !thumbsSwiper.destroyed
                      ? thumbsSwiper
                      : null,
                }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="evolutionSec_slider"
              >
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3 video"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                        <span className="evolutionSec_slider_icon">
                          <em className="icon-video" />
                        </span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div className="evolutionSec_slider_img mb-md-0 mb-3 pdf">
                        {/* <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        /> */}
                        <span className="evolutionSec_slider_icon">
                          <em className="icon-pdf" />
                        </span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div className="evolutionSec_slider_img mb-md-0 mb-3 audio">
                        {/* <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        /> */}
                        <span className="evolutionSec_slider_icon">
                          <em className="icon-mic" />
                        </span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
                <SwiperSlide>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div
                        className="evolutionSec_slider_img mb-md-0 mb-3"
                        onClick={() => setModalImage(true)}
                      >
                        <ImageElement
                          source="theme04/feb-2002.webp"
                          className="img-fluid"
                          alt="feb-2002"
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="evolutionSec_slider_cnt">
                        <h3>
                          The Unfolding Canvas, Personal Development in 2022
                        </h3>
                        <p>
                          Drawing near to the conclusion of this timeline, 2022
                          unfolded as a canvas rich with profound personal
                          growth. This chapter intricately wove together
                          meaningful connections and self-discovery, forming a
                          vibrant mosaic of experiences that played a pivotal
                          role in shaping the narrative of a fulfilled life.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
              </Swiper>
            </div>
          </Container>
        </section>

        {/* theme04 family tree  */}
        {/* <section
          className="familyTree py-80 bg-white position-relative"
          id="familytree"
        >
          <div className="commonHead text-md-center">
            <div className="commonHead_sub">Generations in Harmony</div>
            <h2 className="commonHead_title mb-0">Our Family Tree</h2>
          </div>
          <div>
            <div className="familyTreeContainer mx-auto">
              <div className="tree">
                <ul className="tree_inner">
                  <li className="parent">
                    <div className="d-flex align-items-end parentsWrap  justify-content-center">
                      <div className="spouseParents">
                        <div className="d-flex align-items-end grandParents flex-column justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user13.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user14.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user13.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user14.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul>
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user27.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user12.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="mainParents">
                        <div className="d-flex align-items-end grandParents flex-column justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user13.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user14.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user13.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user14.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul>
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user15.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user16.jpg"
                                  />
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <ul className="treeWrap">
                      <li className="child">
                        <div className="d-flex flex-column justify-content-center">
                          <Link className="spouse">
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user15.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>Sheila Williams</h2>
                                <p>Sep 12, 1964</p>
                                <span>Aunt</span>
                              </div>
                            </div>
                          </Link>
                          <Link>
                            <div className="familyCard">
                              <div className="familyCard_img">
                                <span className="d-flex align-items-center justify-content-center position-absolute">
                                  <em className="icon-info" />
                                </span>
                                <ImageElement
                                  className="img-fluid"
                                  source="family-tree/user14.jpg"
                                />
                              </div>
                              <div className="familyCard_cnt">
                                <h2>Ron Williams</h2>
                                <p>May 1961 - Dec 2022</p>
                                <span>Uncle</span>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <ul>
                          <li className="child child-ex">
                            <div className="d-flex align-items-center flex-column justify-content-center">
                              <Link className="spouse">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user16.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Robert Williams</h2>
                                    <p>Sep 25, 1962</p>
                                    <span>Partner</span>
                                  </div>
                                </div>
                              </Link>
                              <Link className="pe-none">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user13.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Eva Williams</h2>
                                    <p>May 25, 1965</p>
                                    <span>Mother</span>
                                  </div>
                                </div>
                              </Link>
                              <Link>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user16.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Robert Williams</h2>
                                    <p>Sep 25, 1962</p>
                                    <span>Father</span>
                                  </div>
                                </div>
                              </Link>
                            </div>
                            <ul>
                              <li className="child">
                                <div className="d-flex flex-column justify-content-center">
                                  <Link className="spouse">
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user19.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Amanda Williams</h2>
                                        <p>Dec 15, 1988</p>
                                        <span>Brother's Wife</span>
                                      </div>
                                    </div>
                                  </Link>
                                  <Link>
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user20.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Francisco Williams</h2>
                                        <p>Feb 15, 1985</p>
                                        <span>Brother</span>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <ul>
                                  <li className="child">
                                    <div className="d-flex flex-column justify-content-center">
                                      <Link>
                                        <div className="familyCard">
                                          <div className="familyCard_img">
                                            <span className="d-flex align-items-center justify-content-center position-absolute">
                                              <em className="icon-info" />
                                            </span>
                                            <ImageElement
                                              className="img-fluid"
                                              source="family-tree/user29.jpg"
                                            />
                                          </div>
                                          <div className="familyCard_cnt">
                                            <h2>Lula Williams</h2>
                                            <p>Jan 29, 2020</p>
                                            <span>Brother's Son</span>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="d-flex flex-column justify-content-center">
                                      <Link>
                                        <div className="familyCard">
                                          <div className="familyCard_img">
                                            <span className="d-flex align-items-center justify-content-center position-absolute">
                                              <em className="icon-info" />
                                            </span>
                                            <ImageElement
                                              className="img-fluid"
                                              source="family-tree/user30.jpg"
                                            />
                                          </div>
                                          <div className="familyCard_cnt">
                                            <h2>Mark Williams</h2>
                                            <p>Dec 30, 2022</p>
                                            <span>Brother's Daughter</span>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li className="child">
                                <Link>
                                  <div className="familyCard">
                                    <div className="familyCard_img">
                                      <span className="d-flex align-items-center justify-content-center position-absolute">
                                        <em className="icon-info" />
                                      </span>
                                      <ImageElement
                                        className="img-fluid"
                                        source="family-tree/user21.jpg"
                                      />
                                    </div>
                                    <div className="familyCard_cnt">
                                      <h2>Zula Williams</h2>
                                      <p>May 11, 1990</p>
                                      <span>Sister</span>
                                    </div>
                                  </div>
                                </Link>
                              </li>
                              <li className="child">
                                <div className="d-flex flex-column justify-content-center">
                                  <Link className="spouse">
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user27.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Me</h2>
                                        <p>Dec 21, 1988</p>
                                      </div>
                                    </div>
                                  </Link>
                                  <Link>
                                    <div className="familyCard">
                                      <div className="familyCard_img">
                                        <span className="d-flex align-items-center justify-content-center position-absolute">
                                          <em className="icon-info" />
                                        </span>
                                        <ImageElement
                                          className="img-fluid"
                                          source="family-tree/user26.jpg"
                                        />
                                      </div>
                                      <div className="familyCard_cnt">
                                        <h2>Cynthia Williams</h2>
                                        <p>May 20, 1986</p>
                                        <span>Husband</span>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                                <ul>
                                  <li className="child">
                                    <div className="d-flex flex-column justify-content-center">
                                      <Link>
                                        <div className="familyCard">
                                          <div className="familyCard_img">
                                            <span className="d-flex align-items-center justify-content-center position-absolute">
                                              <em className="icon-info" />
                                            </span>
                                            <ImageElement
                                              className="img-fluid"
                                              source="family-tree/user24.jpg"
                                            />
                                          </div>
                                          <div className="familyCard_cnt">
                                            <h2>Perdo Williams</h2>
                                            <p>Feb 28, 2022</p>
                                            <span>Son</span>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                          <li className="child">
                            <div className="d-flex flex-column justify-content-center">
                              <Link className="spouse">
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user25.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Donald Williams</h2>
                                    <p>Nov 21, 1959</p>
                                    <span>Uncle</span>
                                  </div>
                                </div>
                              </Link>
                              <Link>
                                <div className="familyCard">
                                  <div className="familyCard_img">
                                    <span className="d-flex align-items-center justify-content-center position-absolute">
                                      <em className="icon-info" />
                                    </span>
                                    <ImageElement
                                      className="img-fluid"
                                      source="family-tree/user02.jpg"
                                    />
                                  </div>
                                  <div className="familyCard_cnt">
                                    <h2>Cynthia Williams</h2>
                                    <p>May 1961 </p>
                                    <span>Aunt</span>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="controls">
                <button onClick={fitToScreen}>
                  <em className="icon-screenfit" />
                </button>
                <button onClick={zoomIn}>
                  <em className="icon-plus" />
                </button>
                <button onClick={zoomOut}>
                  <em className="icon-minus" />
                </button>
                <button onClick={toggleFullscreen}>
                  <em className="icon-treeexpand" />
                </button>
              </div>
            </div>
          </div>
        </section> */}
        {/* theme01 family tree section (use temporarily until theme02 css can be updated) */}
        <section
          className={` familyTree py-80 ${isFullscreen ? "fullWidth" : ""}`}
          id="familytree"
        >
          <div className="familyTreeContainer mx-auto">
            <div className="commonHead text-center">
              <div className="commonHead_sub text-white">
                The Legacy Lives On
              </div>
              <h2 className="commonHead_title text-white">Our Family Tree</h2>
            </div>
            <div className="familyTreeContainer mx-auto">

              <div className="tree">
                <ul className="tree_inner">
                  <li className="parent" >
                    <div className="d-flex align-items-end parentsWrap  justify-content-center">
                      <div className="spouseParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user27.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user12.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="mainParents">
                        <div className="d-flex align-items-end grandParents flex-row-reverse justify-content-center">
                          <div className="grandParents_item">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="grandParents_item ">
                            <a href="#!" className="spouse multipleParents">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user13.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>Father</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="multipleParents">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user14.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>M G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>Mother</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <ul className="multipleParents">
                          <li className="child">
                            <a href="#!" className="spouse">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user15.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Mother</h2>
                                  <p>May 1961 - Dec 2022</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                            <a href="#!">
                              <div className="heart d-flex align-items-center justify-content-center">
                                <em className="icon-heart" />
                              </div>
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement className="img-fluid" source="family-tree/user16.jpg" />
                                  <span className="d-flex align-items-center justify-content-center">
                                    <em className="icon-info" />
                                  </span>
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>G Father</h2>
                                  <p>May 1961 - June 2000</p>
                                  <p>-</p>
                                </div>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <ul>
                      <li className="child">
                        <Link className="spouse">
                          <div className="familyCard">
                            <div className="familyCard_img">
                              {/* <div className="familyCard_tag" >Parents</div> */}
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user06.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Mother</h2>
                              <p>June 15, 1985 </p>
                              <p>Elder Brother</p>
                            </div>
                          </div>
                        </Link>
                        <Link>
                          <div className="heart d-flex align-items-center justify-content-center position-absolute">
                            <em className="icon-heart" />
                          </div>
                          <div className="familyCard">
                            <div className="familyCard_img">
                              <ImageElement
                                className="img-fluid"
                                source="family-tree/user03.jpg"
                              />
                              <span className="d-flex align-items-center justify-content-center position-absolute">
                                <em className="icon-info" />
                              </span>
                            </div>
                            <div className="familyCard_cnt">
                              <h2>Father</h2>
                              <p>May 11, 1988 </p>
                              <p>Brother's Wife</p>
                            </div>
                          </div>
                        </Link>
                        <ul className="multipleParents bottom">
                          <li className="child">
                            <Link className="pe-none">
                              <div className="familyCard">
                                <div className="familyCard_img">
                                  <ImageElement
                                    className="img-fluid"
                                    source="family-tree/user09.jpg"
                                  />
                                  {/* <span className="d-flex align-items-center justify-content-center position-absolute">
                                        <em className="icon-info" />
                                      </span> */}
                                </div>
                                <div className="familyCard_cnt">
                                  <h2>Me </h2>
                                  <p>January 11, 2020 </p>
                                  <p>Brother's Son</p>
                                </div>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <div className="controls">
                  <button onClick={fitToScreen}>
                    <em className="icon-screenfit" />
                  </button>
                  <button onClick={zoomIn}>
                    <em className="icon-plus" />
                  </button>
                  <button onClick={zoomOut}>
                    <em className="icon-minus" />
                  </button>
                  <button onClick={toggleFullscreen}>
                    <em className="icon-treeexpand" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonial section */}
        <section className="testimonialsSec bg-700 py-80" id="story">
          <Container>
            <div className="commonHead commonHead-light">
              <Row className="align-items-end">
                <Col md={6} className="mb-md-0 mb-3 text-sm-start text-center">
                  <div className="commonHead_sub">Heartfelt Reflections</div>
                  <h2 className="commonHead_title mb-0">
                    Memories of Tommy M. Lawrence
                  </h2>
                </Col>
                <Col md={6} className="text-sm-end text-start text-center">
                  {" "}
                  <div className="d-flex justify-content-sm-end justify-content-center btnFlex">
                    <RippleEffect>
                      <Link
                        to="/pending-comments"
                        className="mt-0 rounded btn btn-outline-white"
                      >
                        Pending Comments
                      </Link>
                    </RippleEffect>
                    <RippleEffect extraClassName="justify-content-end">
                      <CommonButton
                        variant="danger"
                        size="lg"
                        className="rounded mt-0 ms-sm-auto px-xxl-4"
                        onClick={() => setCommentModal(true)}
                      >
                        Share A Story
                      </CommonButton>
                    </RippleEffect>
                  </div>
                </Col>
              </Row>
            </div>
            {/* Slider  */}
            <Swiper
              navigation={true}
              modules={[Navigation]}
              spaceBetween={20}
              className="testimonialSlider"
            >
              <SwiperSlide className="sliderLeft">
                <Row>
                  <Col md={7}>
                    <div>
                      <p className="sliderLeft_cnt">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                        It was popularised in the 1960s Lorem Ipsum is simply
                        dummy text of the printing and typesetting industry.
                      </p>
                    </div>
                  </Col>
                  <Col md={5} className="mb-md-0 mb-3 ps-xl-5">
                    <ImageElement
                      source="theme04/slider-img.webp"
                      className="sliderLeft_img img-fluid"
                      alt="slider-img"
                    />
                  </Col>
                </Row>
                <div className="sliderLeft_profile d-flex align-items-center">
                  <ImageElement
                    source="testimonial-08.webp"
                    className="img-fluid"
                    alt="testimonial"
                  />
                  <div className="ms-md-3 ms-2">
                    <p className="text-truncate mb-0">Cindy E. Thomas</p>
                    <span className="text-truncate  d-flex align-items-center">
                      <em className="icon-location me-md-2 me-1" /> San
                      Francisco, CL
                    </span>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className="sliderLeft">
                <Row>
                  <Col md={7}>
                    <div>
                      <p className="sliderLeft_cnt">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                        It was popularised in the 1960s Lorem Ipsum is simply
                        dummy text of the printing and typesetting industry.
                      </p>
                    </div>
                  </Col>
                  <Col md={5} className="mb-md-0 mb-3 ps-xl-5">
                    <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox slider_imgbox-pdf">
                      <ImageElement
                        className="smallPic"
                        source="theme02/pdf-white.webp"
                        alt="logo"
                      />
                      <Link className="viewBtn">View PDF</Link>
                    </div>
                  </Col>
                </Row>
                <div className="sliderLeft_profile d-flex align-items-center">
                  <ImageElement
                    source="testimonial-07.webp"
                    className="img-fluid"
                    alt="testimonial"
                  />
                  <div className="ms-3">
                    <p className="mb-0">John D. Raphell</p>
                    <span className="d-flex align-items-center">
                      <em className="icon-location me-2" /> Los Angeles, CL
                    </span>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className="sliderLeft">
                <Row>
                  <Col md={7}>
                    <div>
                      <p className="sliderLeft_cnt">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                        It was popularised in the 1960s Lorem Ipsum is simply
                        dummy text of the printing and typesetting industry.
                      </p>
                    </div>
                  </Col>
                  <Col md={5} className="mb-md-0 mb-3 ps-xl-5">
                    <div className="d-flex align-items-center justify-content-center flex-column slider_imgbox slider_imgbox-pdf">
                      <ImageElement
                        className="smallPic"
                        source="theme02/pdf-white.webp"
                        alt="logo"
                      />
                      <Link className="viewBtn">View PDF</Link>
                    </div>
                  </Col>
                </Row>
                <div className="sliderLeft_profile d-flex align-items-center">
                  <ImageElement
                    source="testimonial-08.webp"
                    className="img-fluid"
                    alt="testimonial"
                  />
                  <div className="ms-3">
                    <p className="mb-0">Cindy E. Thomas</p>
                    <span className="d-flex align-items-center">
                      <em className="icon-location me-2" /> San Francisco, CL
                    </span>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className="sliderLeft">
                <Row>
                  <Col md={7}>
                    <div>
                      <p className="sliderLeft_cnt">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book. It has
                        survived not only five centuries, but also the leap into
                        electronic typesetting, remaining essentially unchanged.
                        It was popularised in the 1960s Lorem Ipsum is simply
                        dummy text of the printing and typesetting industry.
                      </p>
                    </div>
                  </Col>
                  <Col md={5} className="mb-md-0 mb-3 ps-xl-5">
                    <ImageElement
                      source="theme04/slider-img.webp"
                      className="sliderLeft_img img-fluid"
                      alt="slider-img"
                    />
                  </Col>
                </Row>
                <div className="sliderLeft_profile d-flex align-items-center">
                  <ImageElement
                    source="testimonial-08.webp"
                    className="img-fluid"
                    alt="testimonial"
                  />
                  <div className="ms-3">
                    <p className="mb-0">Cindy E. Thomas</p>
                    <span className="d-flex align-items-center">
                      <em className="icon-location me-2" /> San Francisco, CL
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Container>
        </section>
      </main>
      {/* share Modal */}
      <ModalComponent
        show={shareModal}
        size="md"
        title="Share Biography"
        closeButton="true"
        modalExtraClass="sharebiography"
        extraTitleClassName="sharebiography_title"
        onHandleCancel={handleCloseModal}
      >
        <div className="sharebiography_body">
          <form>
            <div className="d-flex align-items-end lh-1">
              <div className="form-group mb-0">
                <label className="form-label lh-sm">Copy Url</label>
                <Input
                  id="url"
                  name="url"
                  className="form-control"
                  placeholder="Enter Url"
                  type="email"
                />
              </div>
              <RippleEffect>
                <Button variant="danger">Copy Link</Button>
              </RippleEffect>
            </div>
          </form>
        </div>
        <div className="sharebiography_footer">
          <h3>Share this link via</h3>
          <ul className="d-flex list-unstyled mb-0">
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="instagram"
              >
                <em className="icon-instagram" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="twitter"
              >
                <em className="icon-twitter" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="youtube"
              >
                <em className="icon-youtube" />
              </Link>
            </li>
            <li>
              <Link
                to="#!"
                className="d-flex justify-content-center align-items-center"
                aria-label="facebook"
              >
                <em className="icon-facebook" />
              </Link>
            </li>
          </ul>
        </div>
      </ModalComponent>
      {/* Comment modal */}
      <ModalComponent
        show={commentModal}
        size="md"
        title="Write Comment"
        closeButton="true"
        modalExtraClass="commentModel"
        extraTitleClassName="commentModel_title"
        onHandleCancel={handleCloseModalComment}
      >
        <div className="commentModel_body">
          <form>
            <div className="d-sm-flex w-100">
              <div className="commentModel_left flex-shrink-0">
                <h2>Upload file</h2>
                {/* after Upload */}

                {/* <div className="customUpload customUpload-icon customUpload-w100 position-relative customUpload-img">                  
                  <div className="ant-upload-select position-relative">
                    <ImageElement
                        source="theme01/timeline-08.webp"
                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                        alt="timeline-img"
                      />
                    </div>                 
                    <div className="text-center cursor-pointer mt-2 w-100 remove">
                        <em className="me-1 icon-delete"></em>
                        Remove</div>
                </div> */}

                {/* before Upload */}
                <div className="uploadMultiSec uploadMultiSec-comment">
                  <p className="mb-0">
                    Select preferences and upload your photo or video.
                  </p>
                  <div className="w-100 uploadMultiSec_inner">
                    <Select
                      placeholder="Select File Type"
                      options={[
                        { value: "Photo", label: "Photo" },
                        { value: "pdf", label: "PDF" },
                      ]}
                    />
                    <Upload className="mt-3">
                      <div className="d-flex justify-content-center align-items-center ms-2 ms-lg-3">
                        <span className="d-flex fw-medium align-items-center">
                          Upload <em className="icon-upload ms-2 ms-lg-3" />
                        </span>
                      </div>
                    </Upload>
                  </div>
                </div>
              </div>
              <div className="commentModel_right w-100">
                <h2>Comment</h2>
                <Row className="g-20">
                  <Col xs={12}>
                    <div className="form-group">
                      <AntTextArea
                        className="form-control form-control-textarea w-100"
                        placeholder="Type Here"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="commentModel_btn d-flex justify-content-end">
                  <RippleEffect>
                    <Button
                      className="btn btn-light rounded"
                      onClick={() => setCommentModal(false)}
                    >
                      Close
                    </Button>
                  </RippleEffect>
                  <RippleEffect>
                    <Button
                      className="btn btn-danger rounded"
                      onClick={() => setCommentModal(false)}
                    >
                      Send
                    </Button>
                  </RippleEffect>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalComponent>
      {/* Report modal */}
      <ModalComponent
        show={showReportModal}
        size="md"
        title="Report Biography"
        closeButton="true"
        modalExtraClass="reportModal"
        extraTitleClassName="reportModal_title"
        onHandleCancel={handleCloseModalReport}
      >
        <form>
          <div className="reportModal_body">
            {/* <h2>Are you sure to want to report this?</h2> */}
            <div className="form-group">
              <label className="form-label lh-sm">Category</label>
              <Select
                placeholder="Select Reason"
                options={[
                  { value: "Category01", label: "Category01" },
                  { value: "Category02", label: "Category02" },
                  { value: "Category03", label: "Category03" },
                ]}
              />
            </div>
            <div className="form-group mb-0">
              <label className="form-label lh-sm">Reason for Report</label>
              <AntTextArea
                className="form-control form-control-textarea"
                placeholder="Type Here"
              />
            </div>
          </div>
          <div className="reportModal_footer text-end">
            <RippleEffect>
              <Button
                className="btn btn-light rounded"
                onClick={() => setReportModal(false)}
              >
                Close
              </Button>
            </RippleEffect>
            <RippleEffect>
              <Button
                className="btn btn-danger rounded"
                onClick={() => setReportModal(false)}
              >
                Send Report
              </Button>
            </RippleEffect>
          </div>
        </form>
      </ModalComponent>
      {/* Memories video modal */}
      <ModalComponent
        show={showVideoModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideo}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <Input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light rounded"
                    onClick={handleSelectAll}
                  >
                    {selectAllChecked ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger rounded">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {videoMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxes[index]}
                    onChange={() => handleCheckboxChange(index)}
                  >
                    <div className="videoCard position-relative">
                      {el.imageShow ? (
                        <Link>
                          <ImageElement source={el.thumbnail} alt="video" />
                        </Link>
                      ) : (
                        <ImageElement source={el.thumbnail} alt="video" />
                      )}
                      <div className="videoCard_cnt d-flex justify-content-between align-items-center position-absolute w-100">
                        <h2 className="mb-0">{el.name}</h2>
                        {el.videoDuration && (
                          <span className="d-inline-block">{el.duration}</span>
                        )}
                      </div>
                      {el.videoIcon && (
                        <Link
                          to="#!"
                          className="videoCard_playbtn position-absolute"
                          onClick={() => handleVideoFullShow(true)}
                        >
                          <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                            <em className="icon-video" />
                          </div>
                        </Link>
                      )}
                      {el.imageIcon && (
                        <Link
                          to="#!"
                          className="videoCard_viewbtn position-absolute"
                          onClick={() => handleImageFullShow(true)}
                        >
                          <div className="videoCard_viewbtn_inner d-flex align-items-center justify-content-center">
                            <em className="icon-eye" />
                          </div>
                        </Link>
                      )}
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories audio modal */}
      <ModalComponent
        show={showAudioModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="audioModal"
        extraTitleClassName="audioModal_title"
        onHandleCancel={handleCloseModalAudio}
      >
        <form>
          <div className="audioModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <Input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light rounded"
                    onClick={handleSelectAllAudio}
                  >
                    {selectAllCheckedAudio ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger rounded">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {audioMemories.map((el, index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesAudio[index]}
                    onChange={() => handleCheckboxChangeAudio(index)}
                  >
                    <div className="audioCard position-relative">
                      <div className="d-flex align-items-center">
                        <Link
                          to="#!"
                          className="audioCard_icon d-flex justify-content-center align-items-center"
                        >
                          <em className="icon-video" />
                        </Link>
                        <div className="w-100">
                          <h3>{el.name}</h3>
                          <div className="audioCard_img d-flex align-items-center">
                            <ImageElement
                              source="audio.svg"
                              alt="audio"
                              className="w-100"
                            />
                            <span>{el.duration}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories video Full modal */}
      <ModalComponent
        show={showVideoFullModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalVideoFull}
      >
        <form>
          <div className="videoModal_body">
            <Row>
              <Col sm={12}>
                <div className="videoCard-full position-relative overflow-hidden">
                  <ImageElement
                    source="modal-video-01.webp"
                    alt="video"
                    className="h-100 w-100 object-cover"
                  />
                  <Link to="#!" className="videoCard_playbtn position-absolute">
                    <div className="videoCard_playbtn_inner d-flex align-items-center justify-content-center">
                      <em className="icon-video" />
                    </div>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories image Full modal */}
      <ModalComponent
        show={showImageFullModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalImageFull}
      >
        <form>
          <div className="videoModal_body">
            <Row>
              <Col sm={12}>
                <div className="videoCard-full position-relative overflow-hidden">
                  <ImageElement
                    source="modal-video-01.webp"
                    alt="video"
                    className="h-100 w-100 object-cover"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Memories Pdf modal */}
      <ModalComponent
        show={showPdfModal}
        size="xl"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={handleCloseModalPdf}
      >
        <form>
          <div className="videoModal_body">
            <div className="d-flex flex-wrap justify-content-between mb-sm-0 mb-3 w-100">
              <div className="commonSearch">
                <div className="form-group mb-0">
                  <div className="commonSearch_icn position-relative">
                    <Input
                      id="serch"
                      name="serch"
                      className="form-control"
                      placeholder="Search Here"
                    />
                    <em className="icon-search position-absolute" />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <RippleEffect extraClassName="me-xl-2 me-1">
                  <Button
                    className="btn btn-light rounded"
                    onClick={handleSelectAllVideo}
                  >
                    {selectAllCheckedVideo ? "Unselect All" : "Select All"}
                  </Button>
                </RippleEffect>
                <RippleEffect extraClassName="ms-md-1 ms-0">
                  <Button className="btn btn-danger rounded">Download</Button>
                </RippleEffect>
              </div>
            </div>
            <Row>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <Col lg={4} sm={6} key={index}>
                  <Checkbox
                    checked={individualCheckboxesVideo[index]}
                    onChange={() => handleCheckboxChangeVideo(index)}
                  >
                    <div className="pdfCard position-relative d-flex align-items-center justify-content-center flex-column">
                      <ImageElement
                        source="theme03/pdf-white.webp"
                        alt="logo"
                      />
                      <h6 className="pdfCard_title text-center mb-0">test</h6>
                      <Link className="viewBtn">View PDF</Link>
                    </div>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>
        </form>
      </ModalComponent>
      {/* Image modal memory */}
      <ModalComponent
        size="md"
        show={showModalImageMemory}
        onHandleCancel={handleCloseModalImageMemory}
        extraClassName="imageSlider"
        backdropClassName="sliderBack"
        pagination={{ clickable: true }}
        closeVariant="white"
      >
        <div className="slider">
          <h2 className="text-center">The Early Years</h2>
          <Swiper
            spaceBetween={20}
            slidesPerView={1.4}
            centeredSlides
            autoplay={{
              delay: 2500,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            loop
            pagination={{
              clickable: true,
            }}
            navigation={{
              nextEl: ".next",
              prevEl: ".prev",
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              575: {
                slidesPerView: 1.3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 1.4,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 1.8,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
          >
            <SwiperSlide>
              <div className="slider_content">
                <h3>Navigating the Campus of Life</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>From Crayons to Graduation</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>A Lifetime in Frames</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>The Early Years</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-01.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>Family Bonds</h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-02.webp"
              />
            </SwiperSlide>
            <SwiperSlide>
              <div className="slider_content">
                <h3>Our Matrimonial Journey </h3>
                <p>
                  Within the tender embrace of the photograph, the pure essence
                  of innocence is beautifully captured, offering a heartfelt
                  glimpse into the precious world of babyhood.
                </p>
              </div>
              <ImageElement
                className="img-fluid slider_img"
                source="theme01/slider-img-03.webp"
              />
            </SwiperSlide>
          </Swiper>
          <div className="slider_btn">
            <Button type="button" className="prev">
              <em className="icon-left-arrow" />
            </Button>
            <Button type="button" className="next">
              <em className="icon-right-arrow" />
            </Button>
          </div>
        </div>
      </ModalComponent>
      {/* Image modal */}
      <ModalComponent
        size="md"
        show={showModalImage}
        onHandleCancel={handleCloseModalImage}
        extraClassName="imageSlider imageSlider-img"
        backdropClassName="sliderBack"
        closeVariant="white"
      >
        <Container>
          <div className="slider_content slider">
            <h2>Family and Growth</h2>
            <h3>January 2024</h3>
            <p className="mb-md-4 mb-3">
              Continued her quest for knowledge, channeling her passion into
              higher education...
            </p>
            <ImageElement
              className="img-fluid slider_img"
              source="theme01/slider-img-02.webp"
              alt="slider-img"
            />
          </div>
        </Container>
      </ModalComponent>
      {/* Memorial Places map modal */}
      <ModalComponent
        // modalHeader="Image Slider"
        size="md"
        show={showModalMap}
        onHandleCancel={handleCloseModalMap}
        extraClassName="imageSlider imageSlider-img"
        backdropClassName="sliderBack"
        closeVariant="white"
      >
        <Container>
          <div className="slider_content slider">
            <h2 className="mb-sm-5 mb-4">The Early Years</h2>
            <ImageElement
              className="img-fluid slider_img w-auto h-100"
              source="theme01/slider-img-01.webp"
            />
          </div>
        </Container>
      </ModalComponent>
    </>
  );
}

export default Theme04;
